import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import state from './state';
import * as actions from './actions';
import getters from './getters';
import mutations from './mutation';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    strict: false, // 严格模式
    plugins: debug ? [createLogger()] : []
});
